"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("./Paragraph.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Paragraph = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _ref$customClass = _ref.customClass,
    customClass = _ref$customClass === void 0 ? "" : _ref$customClass,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "medium" : _ref$size,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? "regular" : _ref$weight,
    children = _ref.children;
  var sizeClass = "text-".concat(size);
  var weightClass = "text-".concat(weight);
  return /*#__PURE__*/_react["default"].createElement("p", {
    ref: ref,
    className: "".concat(sizeClass, " ").concat(weightClass, " ").concat(customClass)
  }, children);
});
var _default = exports["default"] = Paragraph;